import { render, staticRenderFns } from "./TopMenuPhone.vue?vue&type=template&id=24176786"
import script from "./TopMenuPhone.vue?vue&type=script&lang=js"
export * from "./TopMenuPhone.vue?vue&type=script&lang=js"
import style0 from "./TopMenuPhone.vue?vue&type=style&index=0&id=24176786&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports